import React from "react";
import { useNavigate } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import CalendarioUsuario from "./usuario/CalendarioUsuario";

export default function IntranetUsuarioCalendarioPage() {
  const navigate = useNavigate();
  return (
    <div className="intranet-red-theme">
      <CalendarioUsuario onVolver={() => navigate("/menu/intranet/usuario")} />
    </div>
  );
}
